export const quotationWorkspaceEn = {
  photoPreview: "Product photo preview",
  previewPhoto: "Preview photo: {{ref}}",
  photoOf: "Product photo: {{ref}}",
  photoMissing: "This product has no photo.",
  photoFailed: "The photo could not be loaded. You can retry or select the product without a photo.",
  selectProduct: "Select product",
  selectProductRef: "Select product: {{ref}}",
  productSelected: "Already selected",

  legacyReview: "Legacy · review needed",
  legacyReviewHint:
    "This older quotation has no recorded issuance status. Review it before issuing through the new workflow.",
  validityOverrideHint:
    "The explicit valid-until date takes precedence over default validity periods.",
  lineField: "Line {{line}} · {{field}}",
  perUnitNotice:
    "Prices are quoted per unit in {{currency}}. This quotation does not order quantities or calculate a payable total.",
  legacyQuantityNotice:
    "This older quotation contains quantities. Saving this draft will normalize each line to one price unit.",
  productSearch: "Search catalog products",
  productLoadError: "Products could not be loaded.",
  noProducts: "No products match this search.",
  retry: "Retry",
  previous: "Previous",
  next: "Next",
  pageOf: "Page {{page}} of {{pages}}",
  productCurrencyMismatch:
    "Catalog price is in {{currency}}. Enter a price in the quotation currency.",
  defaultValidity:
    "The validity period for quotations on metal products is 6 months, while that for other material products is 1 year.",
  editorHint:
    "Save a draft, review the saved print preview, then issue it. Issued versions are retained when revised.",
  unavailableCustomer: "Selected customer (unavailable)",
  chooseCustomer: "Choose customer",
  generalPriceList: "General price list · no customer on print",
  contact: "Contact person",
  companyContact: "Company information only",
  savedContact: "Saved contact",
  validUntil: "Valid until",
  validityTerms: "Validity terms",
  customerLoadError: "Could not load customers",
  linesRequired: "Add at least one quotation line.",
  customerRequired:
    "Choose a customer or explicitly select a general price list.",
  requiredHeader: "Enter an issue date and currency.",
  reviewCurrency:
    "Review prices and confirm them in the selected currency before saving.",
  currencyCleared:
    "Currency changed. All price fields have been cleared; enter and review the new prices.",
  pricesReviewed: "I have reviewed all prices in this currency.",
  quotation_changed:
    "This quotation changed while you were editing. Reload and review the latest version.",
  quotation_issued_locked:
    "Issued quotations are locked. Create a new revision to make changes.",
  quotation_reprice_required:
    "Changing currency requires reviewing and submitting all line prices.",
  quotation_customer_invalid:
    "Choose an active customer and a contact belonging to that customer.",
  quotation_retry_conflict:
    "This create request was already used. Reload before creating another quotation.",
  quotation_line_invalid:
    "Review product identity, unit and prices. Each line quotes one unit.",
  quotation_publish_required:
    "Before issuing, check the issue date, preparer and validity.",
  quotation_revision_invalid:
    "Only an issued quotation can start a new revision.",
  status_Draft: "Draft",
  status_Issued: "Issued",
  status_Expired: "Expired",
  revision: "Revision",
  archived: "Archived",
  active: "Active",
  lifecycle: "Record visibility",
  preview: "Print preview",
  publish: "Issue quotation",
  revise: "Create revision",
  archive: "Archive",
  view: "View quotation",
  history: "Revision history",
  viewRevision: "View issued version",
  legacyHistory: "This imported quotation has no recorded revision history.",
  draftHint:
    "Draft prices can be edited. Review the recipient, currency and validity before issuing.",
  issuedHint:
    "This issued version is locked. Create a revision to change the quotation; the issued copy remains available in history.",
  archivedHint:
    "This quotation is archived. Its saved prices and issued versions remain available for reference.",
  publishConfirm:
    "Issue this saved version and lock its prices and recipient? This records issuance only; it does not send a message to the customer.",
  reviseConfirm:
    "Create a new draft revision from this quotation? The current issued copy will remain available in history.",
  archiveConfirm:
    "Archive this quotation? Its issued versions and audit history will be retained.",
  priceScheduleHint:
    "Prices are quoted per unit. Unit Price, EXW, DTD and Under-MOQ are independent offers and are not added together.",
  exportPage: "Export this page",
  exportFiltered: "Export all matches",
  allCustomers: "All customers",
  allStatuses: "All statuses",
  from: "Issue date from",
  to: "Issue date to",
  sort: "Sort quotations",
  newest: "Newest issue date",
  oldest: "Oldest issue date",
  invalidDateRange: "The end date must be on or after the start date.",
  event_Created: "Draft created",
  event_Updated: "Draft updated",
  event_Issued: "Quotation issued",
  event_Revised: "New draft revision",
  event_Archived: "Quotation archived",
  refreshRecipient: "Refresh recipient from customer",
  refreshPending:
    "Current customer/contact information will replace the draft recipient when saved. Issued versions remain unchanged.",
  savedRecipientHint:
    "The saved recipient is retained. Use Refresh to intentionally copy current customer details.",
  contactLoadError: "Contact details could not be loaded.",
  editTitle: "Edit quotation",
  autoNumberHint: "The quotation number is assigned when you save.",
  required: "Required",
  printedRecipient: "Printed on the quotation",
  noLines: "No lines yet. Use Add product to pick from the catalog, or Add line to type one in.",
  groups: {
    customer: "Customer", customerHint: "Buyer, contact person and the recipient printed on the quotation.",
    terms: "Terms", termsHint: "Quotation date, print date, validity, currency and preparer.",
    lines: "Quoted items",
    notes: "Remarks & validity",
  },
  sideShow: "Show extra columns",
  sideHide: "Hide extra columns",
  sideColumns: "MCQ, MSQ, DTD price, line remark",
  sideLocked: "A line uses the extra columns, so they stay visible.",
};

export const quotationWorkspaceVi = {
  photoPreview: "Xem ảnh sản phẩm",
  previewPhoto: "Xem ảnh: {{ref}}",
  photoOf: "Ảnh sản phẩm: {{ref}}",
  photoMissing: "Sản phẩm này chưa có ảnh.",
  photoFailed: "Không tải được ảnh. Bạn có thể thử lại hoặc chọn sản phẩm khi chưa có ảnh.",
  selectProduct: "Chọn sản phẩm",
  selectProductRef: "Chọn sản phẩm: {{ref}}",
  productSelected: "Đã chọn",

  legacyReview: "Báo giá cũ · cần rà soát",
  legacyReviewHint:
    "Báo giá cũ chưa ghi nhận trạng thái phát hành. Kiểm tra trước khi phát hành theo quy trình mới.",
  validityOverrideHint:
    "Ngày có hiệu lực đến được chỉ định sẽ ưu tiên hơn các thời hạn mặc định.",
  lineField: "Dòng {{line}} · {{field}}",
  perUnitNotice:
    "Báo giá theo từng đơn vị bằng {{currency}}. Đây không phải đơn đặt hàng và không cộng tổng tiền phải trả.",
  legacyQuantityNotice:
    "Báo giá cũ có số lượng. Lưu bản nháp sẽ chuyển mỗi dòng về một đơn vị báo giá.",
  productSearch: "Tìm sản phẩm trong danh mục",
  productLoadError: "Không tải được sản phẩm.",
  noProducts: "Không có sản phẩm phù hợp.",
  retry: "Thử lại",
  previous: "Trước",
  next: "Tiếp",
  pageOf: "Trang {{page}} / {{pages}}",
  productCurrencyMismatch:
    "Giá danh mục bằng {{currency}}. Hãy nhập giá theo tiền tệ báo giá.",
  defaultValidity:
    "Báo giá sản phẩm kim loại có hiệu lực 6 tháng; sản phẩm chất liệu khác có hiệu lực 1 năm.",
  editorHint:
    "Lưu bản nháp, kiểm tra bản in đã lưu rồi phát hành. Nội dung đã phát hành được giữ khi tạo phiên bản mới.",
  unavailableCustomer: "Khách hàng đã chọn (không còn khả dụng)",
  chooseCustomer: "Chọn khách hàng",
  generalPriceList: "Bảng giá chung · không in thông tin khách hàng",
  contact: "Người liên hệ",
  companyContact: "Chỉ thông tin công ty",
  savedContact: "Liên hệ đã lưu",
  validUntil: "Hiệu lực đến",
  validityTerms: "Điều khoản hiệu lực",
  customerLoadError: "Không tải được khách hàng",
  linesRequired: "Thêm ít nhất một dòng báo giá.",
  customerRequired: "Chọn khách hàng hoặc chọn bảng giá chung.",
  requiredHeader: "Nhập ngày báo giá và tiền tệ.",
  reviewCurrency: "Kiểm tra giá và xác nhận tiền tệ đã chọn trước khi lưu.",
  currencyCleared:
    "Đã đổi tiền tệ. Các trường giá đã được xóa; hãy nhập và kiểm tra giá mới.",
  pricesReviewed: "Tôi đã kiểm tra tất cả giá theo tiền tệ này.",
  quotation_changed:
    "Báo giá đã được thay đổi trong lúc bạn sửa. Tải lại và kiểm tra phiên bản mới nhất.",
  quotation_issued_locked:
    "Báo giá đã phát hành được khóa. Tạo phiên bản mới để chỉnh sửa.",
  quotation_reprice_required:
    "Đổi tiền tệ yêu cầu kiểm tra và nhập lại giá từng dòng.",
  quotation_customer_invalid:
    "Chọn khách hàng đang hoạt động và liên hệ thuộc khách hàng đó.",
  quotation_retry_conflict:
    "Yêu cầu tạo này đã được sử dụng. Tải lại trước khi tạo báo giá khác.",
  quotation_line_invalid:
    "Kiểm tra mã hàng, đơn vị và giá. Mỗi dòng báo giá cho một đơn vị.",
  quotation_publish_required:
    "Trước khi phát hành, kiểm tra ngày báo giá, người lập và hiệu lực.",
  quotation_revision_invalid:
    "Chỉ báo giá đã phát hành mới có thể tạo phiên bản tiếp theo.",
  status_Draft: "Nháp",
  status_Issued: "Đã phát hành",
  status_Expired: "Hết hiệu lực",
  revision: "Phiên bản",
  archived: "Đã lưu trữ",
  active: "Đang sử dụng",
  lifecycle: "Hiển thị bản ghi",
  preview: "Xem trước bản in",
  publish: "Phát hành báo giá",
  revise: "Tạo phiên bản mới",
  archive: "Lưu trữ",
  view: "Xem báo giá",
  history: "Lịch sử phiên bản",
  viewRevision: "Xem bản đã phát hành",
  legacyHistory: "Báo giá được nhập từ hệ thống cũ chưa có lịch sử phiên bản.",
  draftHint:
    "Có thể chỉnh sửa giá trong bản nháp. Kiểm tra người nhận, tiền tệ và hiệu lực trước khi phát hành.",
  issuedHint:
    "Phiên bản đã phát hành được khóa. Tạo phiên bản mới để sửa báo giá; bản đã phát hành vẫn được giữ trong lịch sử.",
  archivedHint:
    "Báo giá đã được lưu trữ. Giá đã lưu và các phiên bản đã phát hành vẫn có thể xem lại.",
  publishConfirm:
    "Phát hành phiên bản đã lưu này và khóa giá cùng thông tin người nhận? Thao tác chỉ ghi nhận phát hành, không gửi tin nhắn cho khách hàng.",
  reviseConfirm:
    "Tạo một phiên bản nháp mới từ báo giá này? Bản đã phát hành hiện tại vẫn được giữ trong lịch sử.",
  archiveConfirm:
    "Lưu trữ báo giá này? Các phiên bản đã phát hành và lịch sử thao tác vẫn được giữ lại.",
  priceScheduleHint:
    "Giá được chào theo từng đơn vị. Unit Price, EXW, DTD và Under-MOQ là các mức chào độc lập, không cộng thành tổng.",
  exportPage: "Xuất trang này",
  exportFiltered: "Xuất tất cả kết quả",
  allCustomers: "Tất cả khách hàng",
  allStatuses: "Tất cả trạng thái",
  from: "Ngày báo giá từ",
  to: "Ngày báo giá đến",
  sort: "Sắp xếp báo giá",
  newest: "Ngày báo giá mới nhất",
  oldest: "Ngày báo giá cũ nhất",
  invalidDateRange: "Ngày kết thúc phải bằng hoặc sau ngày bắt đầu.",
  event_Created: "Đã tạo bản nháp",
  event_Updated: "Đã cập nhật bản nháp",
  event_Issued: "Đã phát hành báo giá",
  event_Revised: "Đã tạo phiên bản nháp mới",
  event_Archived: "Đã lưu trữ báo giá",
  refreshRecipient: "Cập nhật người nhận từ khách hàng",
  refreshPending:
    "Thông tin khách hàng/liên hệ hiện tại sẽ thay thế người nhận trong bản nháp khi lưu. Bản đã phát hành giữ nguyên.",
  savedRecipientHint:
    "Đang giữ người nhận đã lưu. Dùng Cập nhật để chủ động lấy thông tin khách hàng hiện tại.",
  contactLoadError: "Không tải được thông tin liên hệ.",
  editTitle: "Sửa báo giá",
  autoNumberHint: "Số báo giá được cấp khi lưu.",
  required: "Bắt buộc",
  printedRecipient: "In trên báo giá",
  noLines: "Chưa có dòng nào. Bấm Thêm sản phẩm để chọn từ danh mục, hoặc Thêm dòng để gõ tay.",
  groups: {
    customer: "Khách hàng", customerHint: "Bên mua, người liên hệ và người nhận in trên báo giá.",
    terms: "Điều khoản", termsHint: "Ngày báo giá, ngày in, hiệu lực, tiền tệ và người lập.",
    lines: "Hàng báo giá",
    notes: "Ghi chú & hiệu lực",
  },
  sideShow: "Hiện cột phụ",
  sideHide: "Ẩn cột phụ",
  sideColumns: "MCQ, MSQ, giá DTD, ghi chú dòng",
  sideLocked: "Có dòng đang dùng cột phụ nên cột phụ luôn hiện.",
};

export const quotationWorkspaceZh = {
  photoPreview: "预览产品照片",
  previewPhoto: "预览照片：{{ref}}",
  photoOf: "产品照片：{{ref}}",
  photoMissing: "此产品尚无照片。",
  photoFailed: "无法加载照片。您可以重试或在没有照片的情况下选择产品。",
  selectProduct: "选择产品",
  selectProductRef: "选择产品：{{ref}}",
  productSelected: "已选择",

  legacyReview: "旧报价 · 待检查",
  legacyReviewHint: "此旧报价未记录发布状态。请先检查，再使用新流程发布。",
  validityOverrideHint: "指定的有效截止日期优先于默认有效期间。",
  lineField: "第 {{line}} 行 · {{field}}",
  perUnitNotice:
    "以 {{currency}} 按单位报价。此报价不订购数量，也不计算应付总额。",
  legacyQuantityNotice: "此旧报价含数量。保存草稿会将各行调整为一个报价单位。",
  productSearch: "搜索产品目录",
  productLoadError: "无法加载产品。",
  noProducts: "没有符合搜索的产品。",
  retry: "重试",
  previous: "上一页",
  next: "下一页",
  pageOf: "第 {{page}} / {{pages}} 页",
  productCurrencyMismatch:
    "目录价格以 {{currency}} 计价。请输入报价币种的价格。",
  defaultValidity: "金属产品报价有效期为六个月；其他材质产品为一年。",
  editorHint: "保存草稿、检查已保存的打印预览后再发布。修订时保留已发布版本。",
  unavailableCustomer: "已选客户（无法使用）",
  chooseCustomer: "选择客户",
  generalPriceList: "通用价目表 · 不打印客户信息",
  contact: "联系人",
  companyContact: "仅公司信息",
  savedContact: "已保存联系人",
  validUntil: "有效期限",
  validityTerms: "有效期条款",
  customerLoadError: "无法加载客户",
  linesRequired: "请新增至少一行报价。",
  customerRequired: "请选择客户或明确选择通用价目表。",
  requiredHeader: "请输入报价日期及币种。",
  reviewCurrency: "保存前请检查并确认所选币种的价格。",
  currencyCleared: "币种已变更。所有价格已清空；请输入并检查新价格。",
  pricesReviewed: "我已检查此币种的所有价格。",
  quotation_changed: "编辑期间报价已变更。请重新加载并检查最新版本。",
  quotation_issued_locked: "已发布报价已锁定。请创建新版本后修改。",
  quotation_reprice_required: "变更币种需要检查并提交所有行的价格。",
  quotation_customer_invalid: "请选择有效客户及该客户的联系人。",
  quotation_retry_conflict: "此创建请求已使用。创建另一报价前请重新加载。",
  quotation_line_invalid: "请检查产品、单位及价格。每行报价为一个单位。",
  quotation_publish_required: "发布前请检查报价日期、制表人及有效期。",
  quotation_revision_invalid: "仅已发布报价可创建下一版本。",
  status_Draft: "草稿",
  status_Issued: "已发布",
  status_Expired: "已过期",
  revision: "版本",
  archived: "已归档",
  active: "使用中",
  lifecycle: "记录显示",
  preview: "打印预览",
  publish: "发布报价",
  revise: "创建新版本",
  archive: "归档",
  view: "查看报价",
  history: "版本历史",
  viewRevision: "查看已发布版本",
  legacyHistory: "此导入报价尚无版本历史记录。",
  draftHint: "草稿价格可编辑。发布前请检查收件人、币种及有效期限。",
  issuedHint:
    "已发布版本已锁定。请创建新版本以修改报价；已发布副本会保留于历史中。",
  archivedHint: "此报价已归档。已保存价格及已发布版本仍可供查阅。",
  publishConfirm:
    "发布此已保存版本并锁定价格及收件人信息？此操作仅记录发布，不会发送消息给客户。",
  reviseConfirm: "从此报价创建新草稿版本？目前已发布副本仍会保留于历史中。",
  archiveConfirm: "归档此报价？已发布版本及操作历史将予保留。",
  priceScheduleHint:
    "价格按单位报价。单价、EXW、DTD 及低于 MOQ 价格为独立报价，不相加为总额。",
  exportPage: "导出本页",
  exportFiltered: "导出所有符合条件的结果",
  allCustomers: "所有客户",
  allStatuses: "所有状态",
  from: "报价日期起",
  to: "报价日期止",
  sort: "排序报价",
  newest: "最新报价日期",
  oldest: "最早报价日期",
  invalidDateRange: "结束日期不得早于开始日期。",
  event_Created: "已创建草稿",
  event_Updated: "已更新草稿",
  event_Issued: "已发布报价",
  event_Revised: "已创建新草稿版本",
  event_Archived: "已归档报价",
  refreshRecipient: "从客户更新收件信息",
  refreshPending:
    "保存时以目前客户及联系人信息更新草稿收件信息。已发布版本维持不变。",
  savedRecipientHint: "保留已保存收件信息。使用更新以明确应用目前客户信息。",
  contactLoadError: "无法加载联系信息。",
  editTitle: "编辑报价单",
  autoNumberHint: "保存时才会分配报价单号。",
  required: "必填",
  printedRecipient: "打印于报价单",
  noLines: "尚无明细。请用“新增产品”从目录选取，或用“新增项目”手动输入。",
  groups: {
    customer: "客户", customerHint: "买方、联系人，以及打印于报价单上的收件人。",
    terms: "条款", termsHint: "报价日期、打印日期、有效期、币种与制表人。",
    lines: "报价品项",
    notes: "备注与有效期",
  },
  sideShow: "显示其他字段",
  sideHide: "隐藏其他字段",
  sideColumns: "MCQ、MSQ、DTD 价、明细备注",
  sideLocked: "有明细使用其他字段，因此会一直显示。",
};
